import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { deleteProduct, getProductById, getProductPriceHistory, getProducts } from "../../../../api/product";
import { getProductFamilies } from "../../../../api/productFamily";
import { getProductTypes } from "../../../../api/productType";
import { getProductUnitTypes } from "../../../../api/productUnitType";
import { ROLES } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import FiltersCard from "../../../components/filters/Filter";
import Table, { buttonsStyle } from "../../../components/tables/table";
import ProductContent from "./ProductContent";
import { getProductMarcas } from "../../../../api/productMarca";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DuplicarProductoDialog from "../../../components/dialogs/DuplicarProductoDialog";
import CreateProductDialog from "../../../components/dialogs/CreateProductDialog";

function getData(products) {
  let data = [];
  for (let i = 0; i < products.length; ++i) {
    const elem = {};
    const product = products[i];
    elem.referencia = product?.referencia;
    elem.descripcion = product?.descripcion;
    elem.marca = product?.marca?.nombre;
    elem.familia = product?.familia?.descripcion;
    elem.tipoProducto = product?.tipo_producto?.descripcion;
    elem.precio = product?.precio + " €";
    elem.id = product?.id;
    elem.tiene_historial_precio = product?.tiene_historial_precio;

    data = data.concat(elem);
  }
  return data;
}

const initialFilters = {
  familias: [],
  tipoProductos: [],
  marcas: [],
};

function filterProducts(products, filters) {
  return (products || []).filter((item) => {
    if (filters.familias?.length > 0 && !filters.familias.some((family) => family.id === item?.familia?.id)) {
      return false;
    }
    if (filters.marcas?.length > 0 && !filters.marcas.some((marca) => marca.id === item?.marca?.id)) {
      return false;
    }
    if (filters.tipoProductos?.length > 0 && !filters.tipoProductos.some((type) => type.id === item?.tipo_producto?.id)) {
      return false;
    }
    return true;
  });
}

export default function ProductsPage() {
  const [data, setData] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [productFamilies, setProductFamilies] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [productUnitTypes, setProductUnitTypes] = useState([]);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [openProductInfoDialog, setOpenProductInfoDialog] = useState(null);

  const [refresh, setRefresh] = useState(false);

  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  const filterOptionsRef = useRef(filterOptions);

  const [openDuplicarProductoDialog, setOpenDuplicarProductoDialog] = useState(false);
  const [duplicarProducto, setDuplicarProducto] = useState(null);
  const [openCreateProductDialog, setOpenCreateProductDialog] = useState(false);
	const [productToEdit, setProductToEdit] = useState(null);
  const [priceHistoryDialog, setPriceHistoryDialog] = useState(null);

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );
  const isOfferManager = loggedUser?.role?.rango === ROLES.GESTOR_OFERTAS;

  useEffect(() => {
    filterOptionsRef.current = filterOptions;
  }, [filterOptions]);

  const actionButtonStyle = {
    ...buttonsStyle,
    maxWidth: "28px",
    maxHeight: "28px",
    minWidth: "28px",
    minHeight: "28px",
    marginLeft: "0.25rem",
  };

  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <div className="product-actions" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", whiteSpace: "nowrap", width: "100%" }}>
        {elem?.tiene_historial_precio && (
          <Tooltip title="Histórico de precios">
            <Button
              className="product-action-button"
              style={actionButtonStyle}
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setPriceHistoryDialog({ product: elem, loading: true, entries: [] });
                getProductPriceHistory(cell, loggedUser?.accessToken)
                  .then((res) => {
                    setPriceHistoryDialog({ product: elem, loading: false, entries: res.data || [] });
                  })
                  .catch((error) => {
                    setPriceHistoryDialog(null);
                    alertError({ error, customMessage: "No se ha podido cargar el histórico de precios." });
                  });
              }}
            >
              <CalendarTodayIcon fontSize="small" />
            </Button>
          </Tooltip>
        )}
        <Tooltip title="Editar">
          <Button
            className="product-action-button"
            style={actionButtonStyle}
            size="small"
            onClick={(e) => {
              e.stopPropagation();
			  getProductById(cell, loggedUser?.accessToken)
				  .then((res) => {
					  if (res.status === 200) {
						  setProductToEdit(res.data);
						  setOpenCreateProductDialog(true);
					  }
				  })
				  .catch((error) => {
					  alertError({ error, customMessage: "No se ha podido cargar el producto para editarlo." });
				  });
            }}
          >
            <EditIcon fontSize="small" />
          </Button>
        </Tooltip>
        <Tooltip title="Duplicar">
          <Button
            className="product-action-button"
            style={actionButtonStyle}
            size="small"
            onClick={(e) => {
              e.stopPropagation();

              getProductById(cell, loggedUser?.accessToken)
                .then((res) => {
                  if (res.status === 200) {
                    setDuplicarProducto(res.data);
                    setOpenDuplicarProductoDialog(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error,
                    customMessage: "No se ha podido cargar el detalle del producto para duplicarlo.",
                  });
                });
            }}
          >
            <FileCopyIcon fontSize="small" />
          </Button>
        </Tooltip>

        {loggedUser?.role?.rango === ROLES.SUPER_ADMIN && (
          <Tooltip title="Eliminar">
            <Button
              className="product-action-button"
              style={actionButtonStyle}
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedProduct(elem);
                setOpenConfirmDialog(2);
              }}
            >
              <DeleteIcon fontSize="small" />
            </Button>
          </Tooltip>
        )}
      </div>
    );
  }

  const columns = [
    {
      dataField: "referencia",
      text: "Referencia",
      sort: true,
      headerAlign: "left",
      align: "left",
      headerStyle: { width: "13%" },
      style: { width: "13%" },
    },
    {
      dataField: "descripcion",
      text: "Descripción",
      sort: true,
      headerAlign: "left",
      align: "left",
      headerStyle: { width: "32%" },
      style: { width: "32%" },
    },
    {
      dataField: "marca",
      text: "Marca",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "8%" },
      style: { width: "8%" },
    },
    {
      dataField: "familia",
      text: "Família",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "10%" },
      style: { width: "10%" },
    },
    {
      dataField: "tipoProducto",
      text: "Tipo",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "8%" },
      style: { width: "8%" },
    },
    {
      dataField: "precio",
      text: "Precio",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "6%" },
      style: { width: "6%" },
    },
    {
      dataField: "id",
      text: "",
      formatter: buttonFormatter,
      headerAlign: "right",
      align: "right",
      headerStyle: { width: "11%" },
      style: { width: "11%" },
    },
  ].filter((column) => !isOfferManager || column.dataField !== "precio");

  useEffect(() => {
    getProductMarcas(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setMarcas(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las marcas de productos.",
        });
      });
    getProductFamilies(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductFamilies(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las familias de productos.",
        });
      });
    getProductTypes(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductTypes(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los tipos de productos.",
        });
      });
    getProductUnitTypes(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductUnitTypes(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error,
          customMessage: "No se han podido obtener los tipos de unidad.",
        });
      });
    getProducts(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(filterProducts(res.data, filterOptionsRef.current));
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los productos.",
        });
      });
  }, [refresh]);

  const updateFilters = (nextFilters) => {
    setFilterOptions(nextFilters);
    setFilteredData(filterProducts(data, nextFilters));
  };

  const handleClearFilters = () => {
    updateFilters(initialFilters);
  };

  const renderCompactTags = (getLabel) => (values, getTagProps) =>
    values.map((option, index) => (
      <Chip
        {...getTagProps({ index })}
        key={option.id}
        label={getLabel(option)}
        size="small"
        style={{ height: 22, marginTop: 0, marginBottom: 0 }}
      />
    ));

  const renderFiltersContent = () => {
    return (
      <>
        <div className="d-sm-flex w-100">
          <Autocomplete
            className="w-100 mr-3"
            multiple
            id="autocomplete-marcas"
            filterSelectedOptions
            options={marcas}
            getOptionLabel={(option) => option?.nombre}
            value={filterOptions.marcas || []}
            renderTags={renderCompactTags((option) => option?.nombre || "")}
            onChange={(event, selected) => {
              updateFilters({
                ...filterOptions,
                marcas: selected,
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Marcas"
              />
            )}
          />
          <Autocomplete
            className="w-100 mr-3"
            multiple
            id="autocomplete-families"
            filterSelectedOptions
            options={productFamilies}
            getOptionLabel={(option) => option?.descripcion}
            value={filterOptions.familias || []}
            renderTags={renderCompactTags((option) => option?.descripcion || "")}
            onChange={(event, selected) => {
              updateFilters({
                ...filterOptions,
                familias: selected,
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Familia"
              />
            )}
          />
          <Autocomplete
            className="w-100"
            multiple
            id="autocomplete-tipos"
            filterSelectedOptions
            options={productTypes}
            getOptionLabel={(option) => option?.descripcion}
            value={filterOptions.tipoProductos || []}
            renderTags={renderCompactTags((option) => option?.descripcion || "")}
            onChange={(event, selected) => {
              updateFilters({
                ...filterOptions,
                tipoProductos: selected,
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Tipo de Producto"
              />
            )}
          />
        </div>
      </>
    );
  };

  return (
    <>
      <Card>
        <CardHeader headerClassName="px-0">
          <CardHeader
            title="Productos"
            sticky={false}
            headerClassName="d-flex justify-content-between w-100 py-3"
          >
            <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
				onClick={() => {
					setProductToEdit(null);
					setOpenCreateProductDialog(true);
				}}
              >
                Nuevo producto
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <div className="w-100">
            <FiltersCard
              collapsable={false}
              filtersContent={renderFiltersContent}
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              handleClearFilters={handleClearFilters}
            />
          </div>
        </CardHeader>
        <CardBody>
          <div className="products-table">
            <Table
              data={getData(filteredData)}
              columns={columns}
              rowEvents={{
                onClick: (e, row, rowIndex) => {
                  const product = data?.find((x) => x.id === row.id);
                  setSelectedProduct(product);
                  setOpenProductInfoDialog(true);
                },
              }}
            />
          </div>
          <ConfirmDialog
            title={"¿Estás seguro de que quieres eliminar este producto?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteProduct(selectedProduct?.id, loggedUser?.accessToken)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "¡Eliminado!",
                      customMessage: "Producto eliminado con éxito.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar el producto.",
                  });
                });
            }}
          />
          <EntityInfoDialog
            title={"Producto: " + selectedProduct?.descripcion}
            open={openProductInfoDialog}
            setOpen={setOpenProductInfoDialog}
            content={<ProductContent product={selectedProduct} />}
          />
          <Dialog
            open={Boolean(priceHistoryDialog)}
            onClose={() => setPriceHistoryDialog(null)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle>Histórico de precios: {priceHistoryDialog?.product?.descripcion}</DialogTitle>
            <DialogContent dividers>
              {priceHistoryDialog?.loading ? (
                <div className="text-muted py-3">Cargando histórico de precios...</div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Proveedor</th>
                        <th className="text-right">Cantidad</th>
                        <th className="text-right">Precio unitario</th>
                        <th className="text-right">Precio global</th>
                        <th>Disponibilidad</th>
                        <th className="text-center">Seleccionado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(priceHistoryDialog?.entries || []).map((entry, index) => (
                        <tr key={`${entry.fecha}-${entry.proveedor}-${index}`}>
                          <td>{entry.fecha ? new Date(entry.fecha).toLocaleDateString("es-ES") : "-"}</td>
                          <td>
                            <div>{entry.proveedor}</div>
                            {entry.referencia_proveedor && <small className="text-muted">Ref.: {entry.referencia_proveedor}</small>}
                          </td>
                          <td className="text-right">{Number(entry.cantidad || 0).toLocaleString("es-ES")}</td>
                          <td className="text-right">{Number(entry.precio_unitario || 0).toLocaleString("es-ES", { style: "currency", currency: "EUR" })}</td>
                          <td className="text-right">{Number(entry.precio_global || 0).toLocaleString("es-ES", { style: "currency", currency: "EUR" })}</td>
                          <td>
                            {entry.tiene_incidencia_disponibilidad ? (
                              <div className="text-warning font-weight-bold">
                                Incidencia
                                {entry.incidencia_disponibilidad && <small className="d-block text-muted font-weight-normal">{entry.incidencia_disponibilidad}</small>}
                              </div>
                            ) : "Sin incidencias"}
                          </td>
                          <td className="text-center">
                            <Chip size="small" color={entry.seleccionado ? "primary" : "default"} label={entry.seleccionado ? "Sí" : "No"} />
                          </td>
                        </tr>
                      ))}
                      {!priceHistoryDialog?.entries?.length && (
                        <tr><td colSpan={7} className="text-muted text-center py-4">No hay precios históricos registrados.</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setPriceHistoryDialog(null)}>Cerrar</Button>
            </DialogActions>
          </Dialog>
                    {openDuplicarProductoDialog && duplicarProducto && (
          <DuplicarProductoDialog
              title="Duplicar producto"
              open={openDuplicarProductoDialog}
              setOpen={setOpenDuplicarProductoDialog}
              data={duplicarProducto}
              onSave={() => setRefresh(true)}
          />
          )}
          <CreateProductDialog
			title={productToEdit ? "Editar producto" : "Nuevo producto"}
            open={openCreateProductDialog}
			setOpen={(nextOpen) => {
				setOpenCreateProductDialog(nextOpen);
				if (!nextOpen) setProductToEdit(null);
			}}
			productToEdit={productToEdit}
            productMarcas={marcas}
            productFamilies={productFamilies}
            productTypes={productTypes}
            productUnitTypes={productUnitTypes}
            onSave={() => setRefresh(true)}
          />
        </CardBody>
      </Card>
    </>
  );
}
